import { useNavigate } from 'react-router-dom';
import { scrollToSection } from '../../../utils/scroll';
import { handleSectionNavigation } from '../../../utils/navigation';
import './Hero.css';
import heroBackground from '../../../assets/images/hero/hero_background.webp';

import { FiDollarSign, FiUsers, FiUserCheck, FiCreditCard, FiArrowRight, FiArrowUpRight } from 'react-icons/fi';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section id="início" className="hero section">

      <img
        src={heroBackground}
        alt="Imagem de fundo"
        className="hero-background"
      />

      <div className="container">

        <div className="hero-content">

          <div className="title">
            Soluções financeiras
            <p>que te salvam</p>
          </div>

          <p className="subtitle">
            Com o Grupo Egel, transforme suas necessidades em oportunidades
            financeiras.
          </p>

          <div className="box glass">

            <div className="topics">

              <div className="topic">
                <div className="icon-box hero-value-icon">
                  <FiDollarSign />
                </div>

                <span>Aprovação em até 7 dias</span>
              </div>


              <div className="topic">
                <div className="icon-box hero-value-icon">
                  <FiUserCheck />
                </div>

                <span>Sem consulta ao SPC/Serasa</span>
              </div>


              <div className="topic">
                <div className="icon-box hero-value-icon">
                  <FiUsers />
                </div>

                <span>Atendemos mais de 6 mil convênios em todo o Brasil</span>
              </div>

              <div className="topic">
                <div className="icon-box hero-value-icon">
                  <FiCreditCard />
                </div>

                <span>Somos parceiros dos principais bancos do Brasil, como a Caixa, BB e Santander</span>
              </div>

            </div>

            <div className="buttons">

              <a
                href="#contato"
                className="btn btn-primary"
                onClick={(e) =>
                  handleSectionNavigation(
                    e,
                    'contato',
                    navigate,
                    scrollToSection
                  )
                }
              >
                <FiArrowRight />

                <span>Consulte Agora</span>
              </a>


              <a
                href="#simulador"
                className="btn btn-secondary"
                onClick={(e) =>
                  handleSectionNavigation(
                    e,
                    'simulador',
                    navigate,
                    scrollToSection
                  )
                }
              >
                <span>Simular condição</span>

                <FiArrowUpRight />
              </a>

            </div>

          </div>

        </div>

      </div>

    </section>
  );
};

export default Hero;